import React from 'react';
import './PublishButton.scss';
interface IDeleteProps {
  row: any;
  publisher: (row: any) => Promise<void>;
  disabled?: boolean;
}

const PublishButton: React.FC<IDeleteProps> = props => {
  const { row, publisher, disabled } = props;
  return <button className="fa fa-upload" onClick={publisher.bind({}, row)} disabled={disabled} />;
};

export default PublishButton;
